import React, { useState } from 'react'
import PropTypes from 'prop-types'
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

export default function InputPassword({ onChange, password }) {
  const [showPassword, setShowPassword] = useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const endAdornment = () => (
    <InputAdornment position="end">
      <IconButton
        aria-label="mostrar senha"
        onClick={togglePasswordVisibility}
        onMouseDown={togglePasswordVisibility}
        edge="end"
      >
        {showPassword ? <Visibility /> : <VisibilityOff />}
      </IconButton>
    </InputAdornment>
  )

  return (
    <FormControl fullWidth required>
      <InputLabel htmlFor="password">Password</InputLabel>
      <Input
        id="password"
        name="password"
        type={showPassword ? 'text' : 'password'}
        value={password}
        onChange={onChange}
        endAdornment={endAdornment()}
      />
    </FormControl>
  )
}

InputPassword.propTypes = {
  onChange: PropTypes.func.isRequired,
  password: PropTypes.string,
}

InputPassword.defaultProps = {
  password: '',
}
